module.exports = __webpack_public_path__ + "static/media/delete-cross.faa35a54.svg";